import React, { useState, useEffect, memo } from "react";
import Clothesbox from "../../../assets/images/Clothesbox.png";
import calendar from "../../../assets/images/calendar.png";
import recordcircle from "../../../assets/images/record-circle.png";
import location from "../../../assets/images/location.png";
import comment from "../../../assets/images/comment.png";
import camera from "../../../assets/images/camera.png";
// import orderimg from "../../../assets/images/orderimg.png";
import GoogleMap from "../../shared/map";
import { DetailsWrap, QuoteItem, MapMain } from "./styles/DetailsMainStyles";
import { formatDateTime } from "../../../helpers/DateFormate";
// import { getLocationName } from "../../../helpers/getLocationName";
import { truncateText } from "../../../helpers/truncateText";
import Tooltip from "@mui/material/Tooltip";
import { AddressSpan } from "./styles/OrderResultStyle";

const DetailsMain = ({ OrderData = [] }) => {
  const [PickUpLocation, SetPickUpLocation] = useState([]);
  const [DropoffLocation, SetDropoffLocation] = useState([]);

  useEffect(() => {
    if (OrderData && OrderData.stops && OrderData.stops.length > 0) {
      SetPickUpLocation({
        lat: OrderData?.stops[0]?.location?.latitude,
        lng: OrderData?.stops[0]?.location?.longitude,
      });
      SetDropoffLocation({
        lat: OrderData?.stops[1]?.location?.latitude,
        lng: OrderData?.stops[1]?.location?.longitude,
      });
      // get the pickupp accress
      // if (OrderData?.stops[0]?.location) {
      //   const fetchLocationNames = async () => {
      //     const locationName = await getLocationName(
      //       OrderData?.stops[0]?.location?.latitude,
      //       OrderData?.stops[0]?.location?.longitude
      //     );
      //     SetPickUpAddress(locationName);
      //   };
      //   fetchLocationNames();
      // }
      // // get the dropoff name
      // if (OrderData?.stops[1]?.location) {
      //   const fetchLocationNames = async () => {
      //     const locationName = await getLocationName(
      //       OrderData?.stops[1]?.location?.latitude,
      //       OrderData?.stops[1]?.location?.longitude
      //     );

      //     SetDropoffAddress(locationName);
      //   };
      //   fetchLocationNames();
      // }
    }
  }, [OrderData]);

  return (
    <DetailsWrap>
      <QuoteItem>
        {OrderData && OrderData.stops && OrderData.stops.length > 0 && (
          <>
            <div className="Quote_ItemMain">
              <img src={Clothesbox} alt="Clothesbox" />
              <span>{OrderData.stops[0]?.order_detail?.name || "N/A"}</span>
            </div>
            <div className="date_ItemMain">
              <img src={calendar} alt="Clothesbox" />
              <span>
                {OrderData.stops[0]?.order_detail?.datetime &&
                  formatDateTime(OrderData.stops[0]?.order_detail?.datetime)}
              </span>
            </div>
            {OrderData?.stops && OrderData?.stops?.length > 0 && (
              <>
                <div className="pickup_ItemMain">
                  <img src={recordcircle} alt="Clothesbox" />
                  <Tooltip title={OrderData?.stops[0]?.location?.address} arrow>
                    <AddressSpan>
                      {OrderData?.stops[0]?.location?.address}
                    </AddressSpan>
                  </Tooltip>
                </div>
                <div className="drop_ItemMain">
                  <img src={location} alt="Clothesbox" />
                  <Tooltip title={OrderData?.stops[1]?.location?.address} arrow>
                    <AddressSpan>
                      {OrderData?.stops[1]?.location?.address}
                    </AddressSpan>
                  </Tooltip>
                </div>
              </>
            )}

            <div className="many_orders">
              <img src={comment} alt="Clothesbox" />
              <span>
                {truncateText(
                  OrderData.stops[0]?.order_detail?.description || "",
                  30
                )}
              </span>
            </div>
            <div className="orders_image">
              <img src={camera} alt="comment" />
              <div className="orders_image_items">
                {OrderData.stops[0]?.order_detail?.image_urls &&
                  OrderData.stops[0]?.order_detail?.image_urls?.map(
                    (values) => {
                      return (
                        <img
                          src={values?.url}
                          alt={OrderData.stops[0]?.order_detail?.name}
                          className="orderImg"
                          key={values?.id}
                        />
                      );
                    }
                  )}
              </div>

              {/* {OrderData.stops[0]?.order_detail?.image_urls &&
                          OrderData.stops[0]?.order_detail?.image_urls.length >
                            2 && (
                            <span className="more-text">
                              {OrderData.stops[0]?.order_detail?.image_urls
                                .length - 2}{" "}
                              more
                            </span>
                          )} */}
            </div>
          </>
        )}
      </QuoteItem>
      <MapMain>
        {/* <img src={image_map} alt="image_map" /> */}
        {OrderData && OrderData?.stops && OrderData?.stops?.length > 0 && (
          <>
            <GoogleMap
              LocationIcon={false}
              hasRoutes={true}
              PichUpLocation={PickUpLocation}
              DropoffLocation={DropoffLocation}
            />
          </>
        )}
      </MapMain>
    </DetailsWrap>
  );
};

export default memo(DetailsMain);
